/** @module csi/widget/ErrorText */
define([
	"dojo/aspect",
	"dojo/_base/declare",
	"dijit/_WidgetBase",
	"csi/html",
	"csi/locale",
	"csi/widget/MaterialIconWithLabel"
], function(aspect,declare,_WidgetBase,html,locale,MaterialIconWithLabel) {

	return declare(_WidgetBase, {
		/** @property {_WidgetBase} inputWidget - Widget which will be enhanced to display error message */
		inputWidget: null,

		/** @property {String} infoResource - information string that can replace red error text */
		infoResource: "",


		_setInfoResourceAttr: function(str) {
			this._set("infoResource", str);
			this.onInfoMessage();
		},

		/**
		 * Populate info message when there is no error
		 */
		onInfoMessage: function() {
			const domNode = this.domNode;
			const infoResource = this.infoResource;
			if (infoResource) {
				html.clear(domNode, true);
				new MaterialIconWithLabel({
					icon: "info_outline",
					"class":"csi-info-message",
					label: locale.resource(this.infoResource)
				}).placeAt(domNode);
			} else if (infoResource === "") {
				html.clear(domNode, true);
			}
		},

		/**
		 * Override to change the error message text with the notification from the outer widget
		 */
		postCreate: function() {
			var self = this;
			this.onInfoMessage();
			this.own(aspect.after(this.inputWidget, "onErrorMessage", function(message) {
				if (!!self.domNode) {
					html.clear(self.domNode, true);
					if (message) {
						// error message
						html.multiLineText(self.domNode, message);
					} else {
						// info message (if any)
						self.onInfoMessage();
					}
				}

			}, true));
		}

	});
});